import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthGate, AuthCallback } from '@aosenuma/lib-supabase';
import { EncuestaLauncher } from '@aosenuma/encuestas';
import { EquipoShell } from '@/layouts/EquipoShell';
import { BandejaPage } from '@/features/bandeja/BandejaPage';
import { CapturaPage } from '@/features/captura/CapturaPage';
import { ExpedientesPage } from '@/features/expedientes/ExpedientesPage';
import { VisitasPage } from '@/features/visitas/VisitasPage';
import { BitacoraPage } from '@/features/bitacora/BitacoraPage';
import { AccesosPage } from '@/features/admin/AccesosPage';
import { GestorCapas } from '@/features/admin/GestorCapas';

const URL_LANDING = import.meta.env.VITE_PUBLIC_URL_LANDING ?? 'http://localhost:5173';

if (import.meta.env.PROD && !import.meta.env.VITE_PUBLIC_URL_LANDING) {
  throw new Error('VITE_PUBLIC_URL_LANDING requerido en producción');
}

export function App() {
  return (
    <Routes>
      <Route path="/auth/callback" element={<AuthCallback redirectTo="/" />} />
      <Route
        path="*"
        element={
          <AuthGate
            allowed={['admin_aosenuma', 'tecnico_aosenuma', 'auditor']}
            panelScope="aosenuma"
            unauthenticated={URL_LANDING}
            forceEnroll
            mfaTtlMs={8 * 60 * 60 * 1000}
          >
            {/* Encuesta de evaluación post-login (colaboradores técnicos). */}
            <EncuestaLauncher audiencia="equipo" />
            <EquipoShell>
              <Routes>
                <Route path="/" element={<BandejaPage />} />
                <Route path="/captura" element={<CapturaPage />} />
                <Route path="/captura/:parcela_id" element={<CapturaPage />} />
                <Route path="/expedientes" element={<ExpedientesPage />} />
                <Route path="/expedientes/:parcela_id" element={<ExpedientesPage />} />
                <Route path="/visitas" element={<VisitasPage />} />
                <Route path="/bitacora" element={<BitacoraPage />} />
                <Route path="/admin/accesos" element={<AccesosPage />} />
                <Route path="/admin/capas" element={<GestorCapas />} />
                {/* Alias legacy: la antigua "Carga masiva" ahora es el gestor de capas. */}
                <Route path="/admin/carga-predios" element={<Navigate to="/admin/capas" replace />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </EquipoShell>
          </AuthGate>
        }
      />
    </Routes>
  );
}
